import { ModelApi } from '@/services/api/modelApi'
import { AnyObject, Id } from '@/shared/types/builtInTypes'
import axios from 'axios'
import qs from 'qs'

/**
 * order endpoint extends model api to inherit its methods and custom methods up to its needs
 * @param url is the modules names which will
 */
export class CashOutEndpoints<T> extends ModelApi<T> {
  constructor() {
    super('cashout_order')
  }

  getOrderItems(params: AnyObject): Promise<AnyObject[]> {
    return new Promise((resolve, reject) => {
      axios
        .get(`cashout_order/get_order_items/`, {
          params,
          paramsSerializer: params => {
            return qs.stringify(params, {
              arrayFormat: 'comma',
              encode: false
            })
          }
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          this.responseNotify(error.response, 'error')
          reject(error.response)
        })
    })
  }

  /**
   * canceling cashout order
   * @param id of the selected record.
   * */
  cancelOrder(id: Id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`cashout_order/${id}/cancel_cashout_order/`)
        .then(response => {
          this.responseNotify('notifications.canceledSuccessfully')
          resolve(response.data.data)
        })
        .catch(error => {
          this.responseNotify(error.response.data, 'error')
          reject(error.response.data)
        })
    })
  }

  /**
   * decision-making for cashout order
   * @param id of the selected record.
   * @param data
   * */
  setDecision(id: Id, data = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`cashout_order/${id}/cashout_order_decision/`, data)
        .then(response => {
          this.responseNotify('notifications.decisionMadeSuccessfully')
          resolve(response.data.data)
        })
        .catch(error => {
          this.responseNotify(error.response.data, 'error')
          reject(error.response.data)
        })
    })
  }
}
